export default class MenuUtils {

    static removeMenu(menuActions, title) {
        return menuActions.filter(menu => menu.name !== title)
    }

    static removeSubMenu(menuActions, mainMenu, subMenu) {
        const menuPrincipal = menuActions.find(menu => menu.name === mainMenu)
        if(menuPrincipal !== undefined) {
            const menusFilhos = menuPrincipal.children
            const subMenus = menusFilhos.filter(submenu => submenu.name !== subMenu)
            menuPrincipal.children = subMenus
        }
        return menuActions
     }

    static toggleDefaultExpanded(menuList, title){
        menuList.forEach(menu => {
            if(menu.name === title){
                menu.expanded = !menu.expanded
            }
        })
    }
}
